import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { Modal, Button, message } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined } from "@ant-design/icons";

import { projectSubgraphsPath, projectSubgraphsV2Path } from "../../helpers/paths";
import { SUBGRAPHS_QUERY, DELETE_SUBGRAPH_MUTATION } from "../../helpers/graphql/subgraph";

const { confirm } = Modal;

interface SubgraphFormInputValues {
  projectId: string;
  subgraphId: string;
  cluster: string;
}

export function DeleteSubgraph({ projectId, subgraphId, cluster }: SubgraphFormInputValues) {
  const navigate = useNavigate();

  const [deleteSubgraph, { loading }] = useMutation(DELETE_SUBGRAPH_MUTATION, {
    onCompleted: ({ deleteSubgraph }) => {
      if (deleteSubgraph) {
        message.success("Deleted subgraph!");

        const redirectTo = cluster === 'v2' ? projectSubgraphsV2Path(deleteSubgraph.projectId) : projectSubgraphsPath(deleteSubgraph.projectId)
        navigate(redirectTo);
      }
    },

    refetchQueries: () => [
      {
        query: SUBGRAPHS_QUERY,
        variables: {
          projectId: projectId,
          cluster: cluster,
        },
      },
    ],
  });

  const showDeleteConfirm = () => {
    confirm({
      title: `Are you sure you want to delete "${subgraphId}" subgraph?`,
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        const variables = {
          projectId,
          subgraphId,
          cluster,
        }
        deleteSubgraph({ variables });
      },
    });
  };

  return (
    <Button
      type="ghost"
      style={{
        borderColor: "red",
        color: "red",
      }}
      icon={<DeleteOutlined />}
      onClick={showDeleteConfirm}
      loading={loading}
    >
      Delete
    </Button>
  );
}
